import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DatasetColumnLabelComponent = props => (
  <div className={props.containerClassName}>
    <span className={classNames('main-checkbox-filter__props bg-grey-200', props.iconContainerClassName)}>
      <i data-test="test" className={classNames('icon', props.type === 'categorical' ? 'icon-a-z' : 'icon-1-9')} />
    </span>

    {props.children}
  </div>
);

DatasetColumnLabelComponent.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,

  containerClassName: PropTypes.string,
  iconContainerClassName: PropTypes.string
};

DatasetColumnLabelComponent.defaultProps = {
  iconContainerClassName: 'mr-10'
};

export default DatasetColumnLabelComponent;
